import { useFlags } from '@lendi/launchdarkly';
import React from 'react';
import { useChatOpenTracking, useSmartChatTracking } from '../../../analytics';
import { ChatPanels } from '../../../types';
import { ChatHeader } from '../../ChatHeader';
import { ChatInput } from '../ChatInput';
import MessageList from '../MessageList';
import { MessageListWrapper } from '../style';
import useDebounce from '../useDebounce';
import { FatalError } from './FatalError';
import { useAuthError, useChangePhone, useCheckExistingCustomer, useCodeValidation, useCustomerEmail, useCustomerName, useLeads, useOnTimeout, usePhoneNumberValidation, useRequestCode, useScrollToEnd, useSendCodeAgain, useTimeout, useVerifyCode, } from './hooks';
import { ChangePhoneAction } from './MoreActions/changePhoneAction/index';
import { ContactUs } from './MoreActions/contactUs';
import { SendCodeAction } from './MoreActions/sendCodeAction';
import { authReducer, initialAuthState, initialSmartChatState, smartChatReducer, SmartChatTypes, SmartCheck, } from './states';
import { createGuestMessage, GUEST_IDENTITY } from './utils';
import { useChatAuthAnalytics } from '../../../providers/ChatAnalyicsProvider/index';
export var SmartChat = function () {
    var _a = React.useReducer(smartChatReducer, initialSmartChatState), chatState = _a[0], chatDispatch = _a[1];
    var _b = React.useReducer(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var _c = React.useState(''), messageToSend = _c[0], setMessageToSend = _c[1];
    var authViaSmartChat = useChatAuthAnalytics().authViaSmartChat;
    var messages = chatState.messages, members = chatState.members, isFatalError = chatState.isFatalError, previousCheckpoint = chatState.previousCheckpoint, contantUs = chatState.contantUs, phoneNumber = chatState.phoneNumber, email = chatState.email, firstName = chatState.firstName, showSendCodeAction = chatState.showSendCodeAction, showChangePhoneAction = chatState.showChangePhoneAction;
    var displayRefTheOther = React.useRef(null);
    var debouncedChange = useDebounce(messageToSend, 500);
    // front end validation hooks on every Guest inputs to SmartChat
    // hook for validating phone number
    usePhoneNumberValidation(chatState, chatDispatch);
    // hook for validating code
    useCodeValidation(chatState, chatDispatch);
    useTimeout(debouncedChange, chatState, chatDispatch);
    // onTimeout hook - to send messages with updated message when Guest timeout the interaction
    useOnTimeout(chatState, chatDispatch);
    // action hook if Guest request to send code again
    useSendCodeAgain(chatState, chatDispatch);
    // action hook if Guest request to change phoneNumber
    useChangePhone(chatState, chatDispatch);
    // hook to take scroller to the last new message
    useScrollToEnd(messages, displayRefTheOther);
    useCheckExistingCustomer(chatState, chatDispatch, authDispatch);
    // hook to take customer fisrtname
    useCustomerName(chatState, chatDispatch);
    // hook to take customer email
    useCustomerEmail(chatState, chatDispatch, authDispatch);
    // chat open tracking
    useChatOpenTracking(authViaSmartChat);
    // LALA hooks
    // hook request code to Auth0
    useRequestCode(chatState, authDispatch, chatDispatch);
    // hook verify code to Auth0
    useVerifyCode(chatState, authState, authDispatch, chatDispatch);
    // hook on getting any auth0 error
    useAuthError(chatState, authState, chatDispatch);
    // hook to track smart analytics
    useSmartChatTracking(phoneNumber, email, firstName);
    // leads data
    useLeads({ phoneNumber: phoneNumber, email: email, firstName: firstName, chatDispatch: chatDispatch });
    var send = function () {
        if (!messageToSend) {
            return;
        }
        // if timeout actions are already displayed, just hide them always on sending new message.
        chatDispatch({ type: SmartChatTypes.HIDE_SEND_CODE_ACTION });
        chatDispatch({ type: SmartChatTypes.HIDE_CHANGE_PHONE_ACTION });
        var oldIndex = messages.length > 0 ? messages[messages.length - 1].index : 0;
        // pass message as Guest customer
        chatDispatch({ type: SmartChatTypes.NEW_MESSAGE, payload: createGuestMessage(messageToSend, ++oldIndex) });
        // pass message to Bot for processing
        chatDispatch({ type: SmartChatTypes.PASS_MESSAGE_TO_BOT, payload: messageToSend });
        setMessageToSend('');
    };
    var enableHistoricalThreads = useFlags().enableHistoricalThreads;
    return (React.createElement(React.Fragment, null, isFatalError ? (React.createElement(FatalError, { onRetry: function () {
            chatDispatch({ type: SmartChatTypes.NEXT_SMART_STATE, payload: previousCheckpoint });
            chatDispatch({ type: SmartChatTypes.HIDE_FATAL_ERROR_PAGE });
        } })) : (React.createElement(React.Fragment, null,
        enableHistoricalThreads && React.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        React.createElement(MessageListWrapper, null,
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(MessageList, { identity: GUEST_IDENTITY, members: members, messages: messages, userType: 'customer' }),
                    showSendCodeAction && (React.createElement(SendCodeAction, { onSendAgain: function () {
                            return chatDispatch({
                                type: SmartChatTypes.NEXT_SMART_STATE,
                                payload: SmartCheck.ON_CODE_RESEND_CHECK,
                            });
                        } })),
                    showChangePhoneAction && (React.createElement(ChangePhoneAction, { onPhoneChange: function () {
                            return chatDispatch({
                                type: SmartChatTypes.NEXT_SMART_STATE,
                                payload: SmartCheck.ON_CHANGE_PHONE_NUMBER_CHECK,
                            });
                        } })),
                    contantUs && React.createElement(ContactUs, null),
                    React.createElement("div", { ref: displayRefTheOther })))),
        React.createElement(ChatInput, { value: messageToSend, onChange: function (e) { return setMessageToSend(e.target.value); }, send: send, onKeyDown: function () { } })))));
};
//# sourceMappingURL=index.js.map